import * as ReactDOM from '../../../../node_modules/react-dom/index.js';

export * from '../../../../node_modules/react-dom/index.js';

const isElement = (value) => typeof Element !== 'undefined' && value instanceof Element;

const findFiberHostNode = (fiber) => {
  if (!fiber) {
    return null;
  }

  if (isElement(fiber.stateNode)) {
    return fiber.stateNode;
  }

  return findFiberHostNode(fiber.child) || findFiberHostNode(fiber.sibling);
};

export function findDOMNode(componentOrElement) {
  if (!componentOrElement) {
    return null;
  }

  if (isElement(componentOrElement)) {
    return componentOrElement;
  }

  if (isElement(componentOrElement.list)) {
    return componentOrElement.list;
  }

  if (isElement(componentOrElement.track)) {
    return componentOrElement.track;
  }

  if (isElement(componentOrElement.node)) {
    return componentOrElement.node;
  }

  if (isElement(componentOrElement.innerSlider?.list)) {
    return componentOrElement.innerSlider.list;
  }

  if (isElement(componentOrElement.innerSlider?.track)) {
    return componentOrElement.innerSlider.track;
  }

  const hostNode =
    findFiberHostNode(componentOrElement._reactInternals) || findFiberHostNode(componentOrElement._reactInternalFiber);

  if (hostNode) {
    return hostNode;
  }

  if (typeof componentOrElement.querySelector === 'function') {
    return componentOrElement;
  }

  return null;
}

export default {
  ...ReactDOM,
  findDOMNode,
};
